var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center h-full"},[_c('vs-button',{staticClass:"mx-auto",attrs:{"color":"primary","type":"border","icon-pack":"feather","icon":"icon-send"},on:{"click":_vm.sendEmail}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }